module.exports = __webpack_public_path__ + "static/media/p2008mot2.46af2b8e.jpg";